import React from "react"
import Navbar from "../../../Common/Navbar"
import Footer from "../../../Common/Footer"
// import Sidebar from "../../../Sidebar/Sidebar"
import ExamSheetComp from "./Component/ExamSheetComp"

const ExamSheet =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            {/* <Sidebar /> */}
             <ExamSheetComp/>
        </div>
        <Footer />
        </>
    )
}

export default ExamSheet